import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
const appearances = variant({
  prop: 'variant',
  variants: {
    "default": {
      backgroundColor: get('colors.functional.grey.200')
    },
    info: {
      backgroundColor: get('colors.feedback.info.light'),
      color: get('colors.functional.grey.900')
    },
    success: {
      backgroundColor: get('colors.feedback.success.light'),
      color: get('colors.functional.grey.900')
    },
    warning: {
      backgroundColor: get('colors.feedback.warning.light'),
      color: get('colors.functional.grey.900')
    },
    error: {
      backgroundColor: get('colors.feedback.danger.light'),
      color: get('colors.functional.grey.900')
    }
  }
});
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      padding: props => "".concat(get('space.2')(props), " ").concat(get('space.10')(props)),
      fontSize: get('fontSizes.s')
    },
    medium: {
      padding: props => "".concat(get('space.2')(props), " ").concat(get('space.10')(props)),
      fontSize: get('fontSizes.m')
    },
    large: {
      padding: props => "".concat(get('space.4')(props), " ").concat(get('space.12')(props)),
      fontSize: get('fontSizes.m')
    }
  }
});
const isFullWidth = variant({
  prop: 'width',
  variants: {
    'full-width': {
      width: '100%'
    },
    auto: {
      width: 'auto'
    }
  }
});
const styles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n  border: none;\n  border-radius: ", ";\n  line-height: ", ";\n  & span {\n    color: ", ";\n    font-weight: ", ";\n  }\n  & button {\n    background: none;\n    border: none;\n    padding: 0;\n    padding-left: ", ";\n    display: inline-flex;\n    cursor: pointer;\n  }\n"])), get('borderRadius.xxl'), get('lineHeights.20'), get('colors.functional.grey.900'), get('fontWeights.regular'), get('space.4'));
const TagWrapper = styled.div.attrs(_ref => {
  let {
    fit,
    children
  } = _ref;
  return {
    fit,
    children
  };
}).withConfig({
  shouldForwardProp: prop => !['width', 'fit', 'variant', 'label', 'showClose'].includes(prop)
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n  ", "\n  ", ";\n  > button {\n    margin-bottom: -2px;\n  }\n"])), styles, appearances, fit, isFullWidth);
const variants = {
  appearances,
  fit,
  isFullWidth
};
export { styles, variants, TagWrapper };